import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import {
  DataCacheService,
  CryptlexApiService,
  CtxButtonComponent,
  AuthnService,
  HlmIconComponent,
} from 'ng-ui';
import { LoaderComponent } from 'ng-ui';
import { projectEnv, getResourceDisplayName } from 'utils';

@Component({
  selector: 'ctx-entitlements-view-customer-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    LoaderComponent,
    HlmIconComponent,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    CtxButtonComponent,
    MatDialogClose,
  ],
  templateUrl: './view-entitlements-modal.component.html',
})
export class EntitlementsViewForCustomerComponent implements OnInit {
  displayedColumns: string[] = ['featureName', 'value'];
  featureEntitlements: Record<string, any>[] = [];
  isLoading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public dataCacheService: DataCacheService,
    private apiService: CryptlexApiService,
    private authn: AuthnService
  ) {}
  ngOnInit() {
    this.loadFeatureEntitlement();
  }
  getResourceDisplayName = getResourceDisplayName;
  get projectName() {
    return projectEnv.get('projectName');
  }
  private async loadFeatureEntitlement(): Promise<void> {
    this.isLoading = true;
    const response = await this.apiService.getListUpto2Pages(
      this.featureEntitlementUrl,
      1,
      100
    );
    this.featureEntitlements = response || [];

    this.isLoading = false;
  }
  get featureEntitlementUrl() {
    const licenseId = this.dialogData.resource?.id;
    if (projectEnv.get('projectName') === 'customer-portal') {
      if (this.authn.jwtRole === 'organization-admin') {
        const organizationId =
          this.dataCacheService.getCachedValues('profile')?.organizationId;
        return `/v3/organizations/${organizationId}/licenses/${licenseId}/feature-entitlements`;
      } else {
        return `/v3/me/licenses/${licenseId}/feature-entitlements`;
      }
    }
    const resellerId =
      this.dataCacheService.getCachedValues('profile').resellerId;
    return `/v3/resellers/${resellerId}/licenses/${licenseId}/feature-entitlements`;
  }
}
